import { useCallback } from 'react';
import { isIntercomMessengerBooted, openIntercomChat } from '@client/util/intercomUtil';

interface UseContactSupportOptions {
  subject: string;
  fallbackEmail?: string;
}

export function useContactSupport({
  subject,
  fallbackEmail = 'hello@joinwaterlily.com',
}: UseContactSupportOptions) {
  const contactSupport = useCallback(() => {
    if (isIntercomMessengerBooted()) {
      openIntercomChat();
    } else {
      const encodedSubject = encodeURIComponent(subject);
      const mailtoUrl = `mailto:${fallbackEmail}?subject=${encodedSubject}`;
      (window as Window).open(mailtoUrl, '_blank');
    }
  }, [subject, fallbackEmail]);

  return contactSupport;
}
